export default {
    id: 'FP_PERSONALIZATION',
    title: 'Cookies de Personnalisation',
    description: 'Ces cookies permettent la collecte et le traitement d’informations relatives à votre utilisation de ce service en tant qu\'organisateur, afin de vous adresser ultérieurement du contenu personnalisé sur notre site. Exemple: la page "welcome-back".',
    cookies: [{
        id: 'WELCOME_BACK',
        title: 'Welcome Back',
        group: 'FP_PERSONALIZATION',
        cookieName: {
            is_orga_admin_back: 'is_orga_admin_back',
        },
    }],
};
